export function equalizeCoachCardHeights(container = document) {
  const grids = [...container.querySelectorAll(".l-grid")];
  if (!grids.length) return;

  grids.forEach((grid) => {
    const items = [...grid.querySelectorAll(".l-grid__item")];
    if (!items.length) return;

    const targets = [
      ".c-card__position",
      ".c-card__name",
      ".c-card__content dl:first-of-type",
    ];

    // --- 高さリセット ---
    targets.forEach((selector) => {
      grid.querySelectorAll(selector).forEach((el) => {
        el.style.height = "";
      });
    });

    // --- 行ごとにグループ化 ---
    const rows = [];
    let currentRowTop = null;
    let row = [];

    items.forEach((item) => {
      const top = item.getBoundingClientRect().top;
      if (currentRowTop === null) currentRowTop = top;

      if (Math.abs(top - currentRowTop) > 5) {
        rows.push(row);
        row = [];
        currentRowTop = top;
      }

      row.push(item);
    });

    if (row.length) rows.push(row);

    // --- 高さ揃え ---
    rows.forEach((rowItems) => {
      targets.forEach((selector) => {
        let max = 0;
        const elements = [];

        rowItems.forEach((item) => {
          const el = item.querySelector(selector);
          if (!el) return;
          const h = el.offsetHeight;
          max = Math.max(max, h);
          elements.push(el);
        });

        elements.forEach((el) => {
          el.style.height = `${max}px`;
        });
      });
    });
  });
}

// --- デバウンス関数 ---
function debounce(func, wait = 100) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// --- リサイズ対応 ---
const resizeEqualize = debounce(() => equalizeCoachCardHeights());
window.addEventListener("resize", resizeEqualize);

// 初回実行
equalizeCoachCardHeights();
